/*
 MManager

 Tresc polityki prywatnosci dla mManager 
  
 historia: 
  PM 2021-09-07 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import DaneZbierane from './common/DaneZbierane';
import UdostepnianieDanych from './common/UdostepnianieDanych';
import AdministratorDanych from './common/AdministratorDanych';
import PrzechowywanieDanych from './common/PrzechowywanieDanych';
import WycofywanieDanych from './common/WycofywanieDanych';
import './common/robotoItalic.css';

class MManager extends React.Component<WithStyles<typeof styles>, any> {

    //PM 2021-11-05
    //variant='body2'
    //poprawka DOM
    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Typography variant='body2'><b>Uprawnienia aplikacji</b></Typography>
                <Typography variant='body2'>Aplikacja mobilna może uzyskać dostęp do następujących uprawnień na urządzeniu mobilnym:</Typography>
                <Typography variant='body2'>- odczytu danych z pamięci zewnętrznej urządzenia,</Typography>
                <Typography variant='body2' className={classes.cursive}>m. in. w celu lokalnego odczytu logów (dzienników zdarzeń aplikacji),</Typography>
                <Typography variant='body2'>- zapisu danych do pamięci zewnętrznej urządzenia,</Typography>
                <Typography variant='body2' className={classes.cursive}>m. in. w celu tworzenia i zapisu do plików z logami,</Typography>
                <Typography variant='body2'>- odczytu stanu połączenia Wi-Fi,</Typography>
                <Typography variant='body2' className={classes.cursive}>
                    w celu sprawdzenia i informowania użytkownika o aktywnym połączeniu sieciowym oraz do zbierania danych technicznych w raportach awarii,
                </Typography>
                <Typography variant='body2'>- instalacji pakietów aplikacji,</Typography>
                <Typography variant='body2' className={classes.cursive}>
                    do instalacji aktualizacji jeśli aplikacja była zainstalowana z innego źródła niż sklep z aplikacjami.
                </Typography>
                <Typography variant='body2'>
                    Wszystkie uprawnienia, jakie są nadane przez użytkowników dla aplikacji mobilne są widoczne w panelu ustawień dla danej aplikacji w danym urządzeniu mobilnym. Uprawnienia aplikacji mogą zostać odwołane przez zmianę ustawień na urządzeniu mobilnym, wyczyszczenie danych aplikacji bądź odinstalowanie samej aplikacji.
                </Typography>
                <br />
                <DaneZbierane />
                <br />
                <PrzechowywanieDanych />
                <br />
                <UdostepnianieDanych />
                <br />
                <WycofywanieDanych />
                <br />
                <AdministratorDanych />
            </React.Fragment>
        );
    }
}

const styles = () => ({
    cursive: {
        fontFamily: 'RobotoItalic'
    }
});

export default withStyles(styles)(MManager);
